$('.accordion--simple').each(function () {
    var accordion = $(this);

    $(accordion).find('.click--down').click(function() {
        if ($(this).hasClass('down')) {

            var thisCard = $(this).parent('.accordion--card');
            var thisSlide = $(this).parent().find('.accordion--slide');
            var thisClick = $(this).parent().find('.click--down');

            $(accordion).find('.accordion--slide').not(thisSlide).slideUp(200);
            $(accordion).find('.click--down').not(thisClick).addClass('down').removeClass('up');
            thisCard.siblings().removeClass('active--card');

            $(this).parent().find('.accordion--slide').slideDown(200);
            $(this).addClass('up').removeClass('down');
            thisCard.addClass('active--card');

        } else {
            $(this).parent().find('.accordion--slide').slideUp(200);
            $(this).addClass('down').removeClass('up');
            $(this).parent('.accordion--card').removeClass('active--card');
            
        }
    })
});
$('.accordion--wpc').each(function () {
    var accordion = $(this);

    $(accordion).find('.click--down').click(function() {
        if ($(this).hasClass('down')) {

            var thisCard = $(this).parent('.accordion--card');
            var thisSlide = $(this).parent().find('.accordion--slide');
            var thisClick = $(this).parent().find('.click--down');

            $(accordion).find('.accordion--slide').not(thisSlide).slideUp(200);
            $(accordion).find('.click--down').not(thisClick).addClass('down').removeClass('up');
            thisCard.siblings().removeClass('active--card');

            $(this).parent().find('.accordion--slide').slideDown(200);
            $(this).addClass('up').removeClass('down');
            thisCard.addClass('active--card');

        } else {
            $(this).parent().find('.accordion--slide').slideUp(200);
            $(this).addClass('down').removeClass('up');
            $(this).parent('.accordion--card').removeClass('active--card');
            
        }
    })
});
$('.accordion--once').each(function () {
    var accordion = $(this);

    $(accordion).find('.click--down').click(function() {
        var thisCard = $(this).parent('.accordion--card');

        $(this).parent().find('.accordion--slide').slideDown(200);
        thisCard.addClass('active--card');
    })
});



$('.accordion--tabs').each(function () {
    var tabs = $(this);

    $(tabs).find('.tab--link--acc').click(function () {
        var tabID = $(this).attr('data-tab');
    
        $(tabs).find('#accTab-' + tabID).siblings().removeClass('active');
        $(tabs).find('#accTab-' + tabID).addClass('active');
    })
});

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

